import type { ReviewCycleFilter } from "./components/ReviewCyclesFilters";

export const getFiltersForSearchService = (filters: ReviewCycleFilter, searchTerm?: string) => {
	const finalFilters: {
		status_in?: string[];
		"360_count_gt"?: number;
		name_re?: string;
		automation_status_in?: ["active", "scheduled"] | ["manual", "disabled", "ended"];
	} = {};

	if (filters?.status) {
		finalFilters.status_in = [filters?.status];
	}

	if (filters?.reviews360) {
		finalFilters["360_count_gt"] = 0;
	}

	if (filters?.automation_status) {
		switch (filters.automation_status) {
			case "automated":
				finalFilters.automation_status_in = ["active", "scheduled"];
				break;
			case "non-automated":
				finalFilters.automation_status_in = ["manual", "disabled", "ended"];
				break;
		}
	}

	if (searchTerm) {
		finalFilters.name_re = searchTerm;
	}

	return finalFilters;
};
